import { useCurrentUser } from 'hooks/useCurrentUser';
import { useHubSpot } from 'Root/useHubSpot.am';
import { BrowserUpdate } from './BrowserUpdate';
import { useGoogleAnalyticsScript } from './useGoogleAnalyticsScript';
import { usePageViewTracking } from './usePageViewTracking';
import { useSegmetricsScript } from './useSegmetricsScript';

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: Array<IArguments | object>;
    gtag?: Gtag;
    _hsq?: Array<unknown>;
    hsConversationsSettings?: {
      loadImmediately?: boolean;
      identificationEmail?: string;
      identificationToken?: string;
    };
    HubSpotConversations?: {
      widget: {
        load: (...args: unknown[]) => void;
        open: () => void;
      };
    };
  }
}

interface ScriptLoaderProps {
  googleAnalyticsId: string;
  hubSpotId: string;
}
export function ThirdPartyScriptLoader(props: ScriptLoaderProps) {
  useHubSpot(props.hubSpotId);

  // INFO: We don't load most of the tracking scripts for super admins
  const { data } = useCurrentUser();
  const isSuperAdmin = data?.user?.superAdmin;

  return isSuperAdmin ? null : <ScriptLoader {...props} />;
}

function ScriptLoader({ googleAnalyticsId }: ScriptLoaderProps) {
  useGoogleAnalyticsScript(googleAnalyticsId);
  usePageViewTracking();
  useSegmetricsScript();

  return <BrowserUpdate />;
}
